<template lang="pug">
  .whyExperienceSlide.blue-background(ref="whyExperience")
    .max-width-grid
      h4.white Why do consumers give gifts of experience?<span class="super"><a href="https://nrf.com/sites/default/files/2019-01/Consumer%20View%20Winter%202018-2019_0.pdf" target="_blank">7</a></span>
      .svg-wrapper
        GiftOfExperience
        .text-block.one
          p.p2 Special memory
        .text-block.two
          p.p2 Unique
        .text-block.three
          p.p2 Variety
        .text-block.four
          p.p2 Convenience
        .text-block.five
          p.p2 All
        .text-block.six
          p.p2 Gen Z
        .text-block.seven
          p.p2 Millennial
</template>

<script>
import GiftOfExperience from '@/assets/img/barCharts/giftsOfExperience.svg'

export default {
  name: 'whyExperienceSlide',
  props: {
  },
  data () {
    return {
    }
  },
  mounted () {
    const getBars = this.$el.querySelectorAll('rect')
    const heights = [...getBars].map(el => el.getAttribute('height'))
    const yVal = [...getBars].map(el => el.getAttribute('y'))

    this.timeline = new TimelineLite({ paused: true })
   
    getBars.forEach((bar, i) => {
      let height = parseFloat(heights[i])
      let y = parseFloat(yVal[i])
      let animateFrom = height + y
      this.timeline
        .fromTo(bar, 1, {attr: { y: animateFrom, height: 0 } }, {attr:{ y: yVal[i], height: heights[i] } }, '-=0.75')
    })
  },
  methods: {
    playAnimation () {
      this.timeline.seek(0)
      this.timeline.play()
    },
  },
  components: {
    GiftOfExperience,
  },
}
</script>

<style scoped lang="scss">
.whyExperienceSlide {
  height: 58rem;
  padding-top: 5rem;

  h4 {
    padding-bottom: 3rem;
  }

  .svg-wrapper {
    position: relative;
    text-align: center;
    max-width: 71%;
    margin: 0 auto;
  }

  h4 {
    text-align: center;
  }

  .text-block {
    p {
      color: white;
    }
    &.one {
      top: 71%;
      left: 6%;
    }

    &.two {
      top: 71%;
      left: 33.5%;
    }

    &.three {
      top: 71%;
      left: 58.5%;
    }

    &.four {
      top: 71%;
      left: 81%;
    }

    &.five {
      top: 92.5%;
      left: 25.5%;
    }

    &.six {
      top: 92.5%;
      left: 49%;
    }

    &.seven {
      top: 92.5%;
      left: 71%;
    }
  }

  .super {
    a {
      color: white;
    }
  }

  @media #{$mobile} {
    .svg-wrapper {
      max-width: 88%;
      padding-left: 3rem;
    }

    .text-block {
      &.one {
        left: 8%;
      }

      &.two {
        left: 35.5%;
      }

      &.three {
        left: 59.5%;
      }

      &.four {
        left: 81.5%;
      }

      &.five {
        top: 93%;
        left: 27.5%;
      }

      &.six {
        top: 93%;
        left: 50.5%;
      }

      &.seven {
        top: 93%;
        left: 72%;
      }
    }
  }
}
</style>
